import { EmployeeDTOCivilStatusEnum, TaxConfigDTO } from '../api';

export function calculateRecreationBudget(
  civilStatus: EmployeeDTOCivilStatusEnum | string | null | undefined,
  numberOfKids: number | null | undefined,
  taxConfig: Pick<TaxConfigDTO, 'recreationBaseAmount' | 'recreationPartnerAmount' | 'recreationChildAmount'>,
): number {
  return (
    taxConfig.recreationBaseAmount +
    (civilStatus === EmployeeDTOCivilStatusEnum.Married || civilStatus === EmployeeDTOCivilStatusEnum.CivilUnion
      ? taxConfig.recreationPartnerAmount
      : 0) +
    taxConfig.recreationChildAmount * (numberOfKids || 0)
  );
}
